"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBriefsFlow = exports.resetSelectedPersonas = exports.setSelectedPersonas = exports.updateSelectedPersona = exports.SET_BRIEFS_FLOW = exports.RESET_SELECTED_PERSONAS = exports.SET_SELECTED_PERSONAS = exports.UPDATE_SELECTED_PERSONA = void 0;
var UPDATE_SELECTED_PERSONA = 'UPDATE_SELECTED_PERSONA';
exports.UPDATE_SELECTED_PERSONA = UPDATE_SELECTED_PERSONA;
var SET_SELECTED_PERSONAS = 'SET_SELECTED_PERSONAS';
exports.SET_SELECTED_PERSONAS = SET_SELECTED_PERSONAS;
var RESET_SELECTED_PERSONAS = 'RESET_SELECTED_PERSONAS';
exports.RESET_SELECTED_PERSONAS = RESET_SELECTED_PERSONAS;
var SET_BRIEFS_FLOW = 'SET_BRIEFS_FLOW';
exports.SET_BRIEFS_FLOW = SET_BRIEFS_FLOW;

var updateSelectedPersona = function updateSelectedPersona(persona, index) {
  return {
    type: UPDATE_SELECTED_PERSONA,
    payload: persona,
    index: index
  };
};

exports.updateSelectedPersona = updateSelectedPersona;

var setSelectedPersonas = function setSelectedPersonas(personas) {
  return {
    type: SET_SELECTED_PERSONAS,
    payload: personas
  };
};

exports.setSelectedPersonas = setSelectedPersonas;

var resetSelectedPersonas = function resetSelectedPersonas() {
  return {
    type: RESET_SELECTED_PERSONAS
  };
};

exports.resetSelectedPersonas = resetSelectedPersonas;

var setBriefsFlow = function setBriefsFlow(flow) {
  return {
    type: SET_BRIEFS_FLOW,
    payload: flow
  };
};

exports.setBriefsFlow = setBriefsFlow;